import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Switch from 'flarum/common/components/Switch';
import LinkButton from 'flarum/common/components/LinkButton';
export { default as extend } from './extend';

/**
 * The member's own switch for the recap email.
 *
 * 🚨 The only thing Muster puts in front of a member, and it exists because
 * the extension can now send them mail. An opt-out that lives only in an email
 * footer means digging out an old message to change your mind; this is where
 * somebody looks when they want the mail to stop.
 *
 * 🚨 Hidden entirely when the forum has not switched the recap on. A control
 * for mail that is never sent is a control that does nothing, and it invites
 * exactly one support question: "what is this?"
 *
 * 🚨 The target is a MODULE PATH STRING, not an imported class. SettingsPage is
 * code-split in Flarum 2 and is not in the forum bundle's export map, so
 * `import SettingsPage from 'flarum/forum/components/SettingsPage'` resolves to
 * undefined and `undefined.prototype` throws while the extension is
 * initialising. That does not fail politely: the initializer dies, every
 * extension after it in the list never runs, and the forum serves the
 * "Something went wrong while trying to load the full version of this site"
 * screen. Given a string, `extend` waits for the module to load and applies
 * itself then.
 */
app.initializers.add('ernestdefoe-muster', () => {
  extend('flarum/forum/components/SettingsPage', 'privacyItems', function (items) {
    if (!app.forum.attribute('musterRecapEnabled')) return;
    const user = app.session.user;
    if (!user) return;
    items.add('musterRecap', Switch.component({
      state: user.preferences().musterRecap !== false,
      onchange: value => {
        user.savePreferences({
          musterRecap: value
        });
      }
    }, app.translator.trans('ernestdefoe-muster.forum.recap_toggle')));
  });

  /*
   * The way in for groups granted the worklist without admin rights. Admins
   * hold every permission, so they see it too — it is the same list as the
   * admin page.
   */
  extend('flarum/forum/components/SessionDropdown', 'items', function (items) {
    if (!app.forum.attribute('canSeeMusterWorklist')) return;
    items.add('muster', m(LinkButton, {
      icon: "fas fa-person-walking-arrow-right",
      href: app.route('muster')
    }, app.translator.trans('ernestdefoe-muster.forum.worklist_link')), 45);
  });
});